"use strict";
/**
 * Created on 06 23 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var commons_1 = require("../../core/commons");

var WindowItemPOSPriceRecalcInput_1 = require("../model/WindowItemPOSPriceRecalcInput");

var WindowItemPosAttributesConverter_1 = require("./WindowItemPosAttributesConverter");

var WindowItemPOSPriceRecalcInputConverter_1 = require("./WindowItemPOSPriceRecalcInputConverter");
/**
 * Implementation of {@link WindowItemPOSPriceRecalcInputConverter}.
 *
 * @author JMe
 */


var WindowItemPOSPriceRecalcInputConverterImpl =
/*#__PURE__*/
function (_WindowItemPOSPriceRe) {
  _inherits(WindowItemPOSPriceRecalcInputConverterImpl, _WindowItemPOSPriceRe);

  function WindowItemPOSPriceRecalcInputConverterImpl(attributesConverter) {
    var _this;

    _classCallCheck(this, WindowItemPOSPriceRecalcInputConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPOSPriceRecalcInputConverterImpl).call(this));
    _this.attributesConverter = attributesConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowItemPOSPriceRecalcInputConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      // serialization should not be needed
      throw commons_1.UNIMPLEMENTED("WindowItemPOSPriceRecalcInputConverterImpl.toDocument");
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new WindowItemPOSPriceRecalcInput_1.WindowItemPOSPriceRecalcInput(conversions.asObject(source, 'iId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'attributes', function (v) {
        return _this2.attributesConverter.toObject(v, conversions);
      }), conversions.asClassReferenceIdsSet(source, 'sites'));
    }
  }]);

  return WindowItemPOSPriceRecalcInputConverterImpl;
}(WindowItemPOSPriceRecalcInputConverter_1.WindowItemPOSPriceRecalcInputConverter);

WindowItemPOSPriceRecalcInputConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [WindowItemPosAttributesConverter_1.WindowItemPosAttributesConverter])], WindowItemPOSPriceRecalcInputConverterImpl);
exports.WindowItemPOSPriceRecalcInputConverterImpl = WindowItemPOSPriceRecalcInputConverterImpl;